import { Controller } from 'stimulus';
import nl from '../i18n/datepicker/nl';

let Datepicker;

export class DatepickerController extends Controller {
  connect() {
    this.loadDatepicker()
      .then((module) => {
        Datepicker = module.Datepicker;

        Object.assign(Datepicker.locales, nl);

        this.datepicker = new Datepicker(this.element, {
          ...this.optionsFromElement(),

          language: 'nl',
          buttonClass: 'btn',
        });
      });
  }

  optionsFromElement() {
    const options = this.element.dataset;
    const config = {};

    if (typeof options === 'undefined') {
      return config;
    }

    return this.datasetToConfig(options);
  }

  datasetToConfig(dataset) {
    const config = {};

    Object.keys(dataset).forEach((option) => {
      const regex = /^datepicker/g;

      if (!regex.test(option)) {
        return;
      }

      let value = dataset[option];
      let transformedOption = option.replace('datepicker', '');

      transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

      if (value === 'true') {
        value = true;
      } else if (value === 'false') {
        value = false;
      }

      config[transformedOption] = value;
    });

    return config;
  }

  loadDatepicker() {
    return new Promise((resolve, reject) => {
      import('vanillajs-datepicker')
        .then(resolve)
        .catch(reject);
    });
  }
}

DatepickerController.targets = [];

export default DatepickerController;
